import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sm-btn',
  templateUrl: './sm-btn.component.html',
  styleUrls: ['./sm-btn.component.scss']
})
export class SmBtnComponent implements OnInit {
  @Input() props;
  @Input() valid: boolean = false;

  @Output() kClick = new EventEmitter<any>();


  ngOnInit(): void {
  }
  onBtnClick(event): void {
      // if (!this.props.propreadonly === true) {

          this.kClick.emit(event);
      // }
  }
}
